import JSEncrypt from 'jsencrypt/bin/jsencrypt.min.js';

import { pubKey } from '@/shared/keys';

export class Cryptography {
  private encrypter: any;

  constructor() {
    this.encrypter = new JSEncrypt({ default_key_size: 4096 });
    this.encrypter.setPublicKey(pubKey);
  }

  public encrypt(data: any): string {
    return this.encrypter.encrypt(JSON.stringify(data));
  }
}
